import { useParams } from 'react-router';
import { useContext, useEffect, useRef, useState } from 'react';
import { getCredentials } from '../../api/fetchCreds';
import styles from './styles.js';
import useRoom from '../../hooks/useRoom';
import { UserContext } from '../../context/UserContext';
import { RoomContext } from '../../context/RoomContext';
import { IconButton, Button } from '@material-ui/core';
import ToolBar from 'components/ToolBar';
import GetAppIcon from '@material-ui/icons/GetApp';
import NetworkToast from 'components/NetworkToast';
import useScreenSharing from '../../hooks/useScreenSharing';
import { useHistory } from 'react-router-dom';
export default function VideoRoom() {
  const { user } = useContext(UserContext);
  const { credentials } = useContext(RoomContext);
  const [error, setError] = useState(null);
  const { push } = useHistory();
  const {
    createCall,
    room,
    participants,
    connected,
    networkStatus,
    cameraPublishing,
    localParticipant
  } = useRoom();
  const { isScreenSharing, startScreenSharing, stopScreenSharing } =
    useScreenSharing({ room });
  const roomContainer = useRef();
  const classes = styles();
  let { roomName } = useParams();
  const redirectNewMeeting = () => {
    push('/');
  };

  // useEffect(() => {
  //   getCredentials(roomName)
  //     .then(({ data }) => {
  //       setCredentials({
  //         apikey: data.apikey,
  //         sessionId: data.sessionId,
  //         token: data.token
  //       });
  //     })
  //     .catch((err) => {
  //       setError(err);
  //       console.log(err);
  //     });
  // }, [roomName]);

  useEffect(() => {
    try {
      const { apikey, sessionId, token } = credentials;
      if (apikey && sessionId && token) {
        createCall(credentials, roomContainer.current, user.userName, {
          ...user.defaultSettings
        });
      }
    } catch (err) {
      setError(err);
    }
  }, [createCall, credentials, user]);

  if (error)
    return (
      <div className={classes.meetingInfo}>
        <div >
          <h2>An error has occured.</h2>
          <h2>If the issue continues please contact MeMD support for additional assistance, please give us a call toll-free at 1-855-636-3669. </h2>
          <br></br>
           <IconButton
            onClick={redirectNewMeeting}
            className={classes.new__meeting}
          >
            Continue
          </IconButton> 
          {/* <Button
            onClick={redirectNewMeeting}
          >
            <GetAppIcon />
          </Button> */}

        </div>

      </div>


    );

  return (
    <div id="callContainer" className={classes.callContainer}>
      <div
        id="roomContainer"
        className={classes.roomContainer}
        ref={roomContainer}
      >
        <NetworkToast networkStatus={networkStatus} />
        <div
          id="screenSharingContainer"
          className={classes.screenSharingContainer}
        >
          {isScreenSharing && (
            <div className={classes.screenSharingOverlay}>
              You Are Screensharing
            </div>
          )}
        </div>
      </div>
      <ToolBar
        room={room}
        participants={participants}
        localParticipant={localParticipant}
        connected={connected}
        cameraPublishing={cameraPublishing}
        isScreenSharing={isScreenSharing}
        startScreenSharing={startScreenSharing}
        stopScreenSharing={stopScreenSharing}
      ></ToolBar>
    </div>
  );
}
